module.exports = __webpack_public_path__ + "static/img/img-cp6-1.a9f9bc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-cp6-1.png
// module id = mIrx
// module chunks = 0